import { render, staticRenderFns } from "./book_url.vue?vue&type=template&id=78696228&scoped=true&"
import script from "./book_url.vue?vue&type=script&lang=js&"
export * from "./book_url.vue?vue&type=script&lang=js&"
import style0 from "./book_url.vue?vue&type=style&index=0&id=78696228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78696228",
  null
  
)

export default component.exports